import { z } from 'zod';

import { ZodAmount } from '@Common/types/Amount';
import { ZodB2bSavingPlanCategory } from '@Common/types/b2b/plans';
import { ZodProfileSavingPlanId } from '@Common/types/profile/saving_plans';
import { ZodId } from '@Common/types/request';
import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const ZodTransferScope = z.enum(['individual', 'collective']);

export const ZodEmployeeSavingsOutgoingTransferTransaction = z.object({
  id: ZodTrimmedString,
  external_company_name: ZodTrimmedString.nullable(),
  saving_plan_ids: ZodProfileSavingPlanId.array(),
  company_name: ZodTrimmedString.nullable(),
  plan_category: ZodB2bSavingPlanCategory,
  initiated_date: z.string().datetime(),
  filled_at: z.string().datetime().nullable(),
  status: z.enum(['initiated', 'pending', 'completed', 'rejected']),
  net_amount: ZodAmount.nullable(),
  fees: z
    .object({
      amount: ZodAmount.nullable(),
      rate: z.number().nullable(),
      is_free: z.boolean(),
    })
    .nullable(),
  amount: ZodAmount.nullable(),
  type: z.literal('employee_savings_outgoing_transfer'),
  transaction_statement_document_id: ZodId.nullable(),
  allocations_count: z.number().int().nullable(),
  scope: ZodTransferScope,
});

export type EmployeeSavingsOutgoingTransferTransaction = z.infer<
  typeof ZodEmployeeSavingsOutgoingTransferTransaction
>;
